import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import React from 'react'
import { useTableContext } from '../context'
import { Filter } from '../types'

export default function Filters<T extends object = object>({ components }: Props<T>) {
    const table = useTableContext()

    return (
        <EmphasizedContent>
            <Grid columns="4">
                {components.map((Component, idx) => <Component key={idx} table={table} />)}
            </Grid>
        </EmphasizedContent>
    )
}

interface Props<T extends object = object> {
    components: Filter<T>[]
}